import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '商業空間設計怎麼收費？',
    a: '依空間坪數、設計複雜度與服務範疇而定，設計費通常以坪數計價。我們提供免費初步諮詢，在了解需求後會提供清楚的報價說明。',
  },
  {
    q: '從設計到完工通常要多久？',
    a: '視空間大小與工程複雜度而定。一般中型商業空間（50-150坪）設計階段約4-8週，施工階段約6-12週，我們會在提案時提供明確工期規劃。',
  },
  {
    q: '可以只做設計不做施工嗎？',
    a: '可以。我們提供單純設計規劃服務，業主可自行發包施工，我們也可以提供工班推薦與現場顧問服務。',
  },
  {
    q: '老店翻新可以分階段進行嗎？',
    a: '完全可以。我們可以依預算與營業需求規劃分階段翻新計畫，確保在不完全停業的情況下完成升級改造。',
  },
];

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:gap-20">
          {/* Left */}
          <div className="lg:w-5/12 mb-12 lg:mb-0">
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">FAQ</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35] mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              常見問題
            </h2>
            <p className="text-[#5a5a5a] leading-relaxed mb-8" style={{ fontSize: '1.1875rem' }}>
              有更多問題？我們樂於提供免費初步諮詢，
              一起找出最適合你的商業空間規劃方向。
            </p>
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#b8956a] text-white rounded-full font-medium hover:bg-[#a07d58] transition-colors cursor-pointer whitespace-nowrap text-[1rem]"
            >
              查看全部常見問題
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right - Accordion */}
          <div className="lg:w-7/12">
            <div className="flex flex-col divide-y divide-[#e2ddd8]">
              {faqs.map((f, i) => (
                <div key={i} className="py-5">
                  <button
                    className="w-full flex items-center justify-between gap-4 text-left cursor-pointer"
                    onClick={() => setOpen(open === i ? null : i)}
                  >
                    <span
                      className="font-medium text-[#1a1a1a] leading-snug"
                      style={{ fontSize: '1.0625rem' }}
                    >
                      {f.q}
                    </span>
                    <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                      <i className={`text-[#b8956a] transition-transform duration-300 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                    </div>
                  </button>
                  {open === i && (
                    <p
                      className="mt-4 text-[#5a5a5a] leading-relaxed pr-10"
                      style={{ fontSize: '1rem' }}
                    >
                      {f.a}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
